import { render, staticRenderFns } from "./ForHired.vue?vue&type=template&id=49707061&scoped=true"
import script from "./ForHired.vue?vue&type=script&lang=js"
export * from "./ForHired.vue?vue&type=script&lang=js"
import style0 from "./ForHired.vue?vue&type=style&index=0&id=49707061&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49707061",
  null
  
)

export default component.exports